<div class="section">
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <h1 class="title font-weight-bold text-dark text-center">
          {{ 'risk.riskWarning' | translate }}
        </h1>
      </div>
    </div>
  </div>

  <div class="container-fluid tw-pt-[30px]">
    <div class="row">
      <div class="col-11 mx-auto col-md-8 offset-md-2 tw-pb-8">
        <strong class="tw-text-black">{{ 'risk.tableOfContents' | translate }}</strong>
        <ol class="tw-pl-5">
          <li>
            <a routerLink="." fragment="ecf" class="table-content__link !tw-underline">{{
              'risk.riskWarningTitle' | translate
            }}</a>
          </li>
          <li>
            <a routerLink="." fragment="tcf" class="table-content__link !tw-underline">{{
              'riskIeo.riskWarningTitle' | translate
            }}</a>
          </li>
          <li *ngIf="notesEnabled">
            <a routerLink="." fragment="note" class="table-content__link !tw-underline">{{
              'riskNote.tocLink' | translate
            }}</a>
          </li>
        </ol>
      </div>

      <section id="ecf" autoscroll="true" class="col-11 mx-auto col-md-8 offset-md-2">
        <h2 class="tw-text-3xl tw-font-bold tw-uppercase">
          {{ 'risk.riskWarningTitle' | translate }}
        </h2>
        <p>{{ 'risk.riskWarningDesc1' | translate }}</p>
        <p>{{ 'risk.riskWarningDesc2' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.businessRisk' | translate }}</h3>
        <p>{{ 'risk.businessRiskDesc' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.illiquidity' | translate }}</h3>
        <p>{{ 'risk.illiquidityDesc' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.returns' | translate }}</h3>
        <p>{{ 'risk.returnsDesc' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.dilution' | translate }}</h3>
        <p>{{ 'risk.dilutionDesc' | translate }}</p>
        <h3 class="subtitle">
          {{ 'risk.spreadYourRisks' | translate }}; {{ 'risk.researchWell' | translate }}
        </h3>
        <p>{{ 'risk.spreadYourRisksDesc' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.noGuarantee' | translate }}</h3>
        <p>
          {{ 'risk.noGuaranteeDesc' | translate }}
        </p>
        <h3 class="subtitle">{{ 'risk.noCoverTitle' | translate }}</h3>
        <p>
          {{ 'risk.noCoverECFDesc' | translate }}
        </p>
      </section>
    </div>
  </div>

  <hr />

  <div class="container-fluid">
    <div class="row">
      <section id="tcf" autoscroll="true" class="col-11 mx-auto col-md-8 offset-md-2">
        <h2 class="tw-text-3xl tw-font-bold tw-uppercase">
          {{ 'riskIeo.riskWarningTitle' | translate }}
        </h2>
        <p>{{ 'riskIeo.riskWarningDesc1' | translate }}</p>
        <p>{{ 'riskIeo.riskWarningDesc2' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.businessRisk' | translate }}</h3>
        <p>{{ 'riskIeo.businessRiskDesc' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.illiquidity' | translate }}</h3>
        <p>{{ 'riskIeo.illiquidityDesc' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.returns' | translate }}</h3>
        <p>{{ 'riskIeo.returnsDesc' | translate }}</p>
        <h3 class="subtitle">
          {{ 'risk.spreadYourRisks' | translate }}; {{ 'risk.researchWell' | translate }}
        </h3>
        <p>{{ 'riskIeo.spreadYourRisksDesc' | translate }}</p>
        <h3 class="subtitle">{{ 'risk.noCoverTitle' | translate }}</h3>
        <p>
          {{ 'riskIeo.noCoverTCFDesc' | translate }}
        </p>
      </section>
    </div>
  </div>

  <!-- P2P-28 · F0.3 — Note (P2P) risk section. Ships dark behind the P2P-29 notesEnabled
       flag with clearly-marked DRAFT copy until Legal delivers the final text (§2.3). -->
  <ng-container *ngIf="notesEnabled">
    <hr />
    <div class="container-fluid">
      <div class="row">
        <section id="note" autoscroll="true" class="col-11 mx-auto col-md-8 offset-md-2">
          <h2 class="tw-text-3xl tw-font-bold tw-uppercase">
            {{ 'riskNote.riskWarningTitle' | translate }}
          </h2>
          <p class="tw-my-3 tw-inline-block tw-rounded tw-bg-yellow-100 tw-px-2 tw-py-1 tw-text-sm tw-font-bold tw-uppercase tw-text-yellow-800">
            {{ 'riskNote.draftBadge' | translate }}
          </p>
          <p>{{ 'riskNote.riskWarningDesc1' | translate }}</p>
          <h3 class="subtitle">{{ 'riskNote.capitalLoss' | translate }}</h3>
          <p>{{ 'riskNote.capitalLossDesc' | translate }}</p>
          <h3 class="subtitle">{{ 'riskNote.illiquidity' | translate }}</h3>
          <p>{{ 'riskNote.illiquidityDesc' | translate }}</p>
          <h3 class="subtitle">{{ 'riskNote.noCmcf' | translate }}</h3>
          <p>{{ 'riskNote.noCmcfDesc' | translate }}</p>

          <!-- Lightweight content changelog: editorial edits publish without a new version,
               so the page keeps its own date + what-changed trail for the audit story. -->
          <div class="tw-mt-8 tw-border-t tw-pt-4 tw-text-sm tw-text-gray-500">
            <strong>{{ 'riskNote.changelogTitle' | translate }}</strong>
            <ul class="tw-mt-1 tw-list-disc tw-pl-5">
              <li>{{ 'riskNote.changelogInitial' | translate }}</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </ng-container>
</div>
